class PdpSaleTimer extends HTMLElement {
  connectedCallback() {
    this.endTime = Number(this.dataset.endTime);
    this.hideWhenExpired = this.dataset.hideWhenExpired === 'true';
    this.hoursEl = this.querySelector('[data-pdp-sale-timer-hours]');
    this.minutesEl = this.querySelector('[data-pdp-sale-timer-minutes]');
    this.secondsEl = this.querySelector('[data-pdp-sale-timer-seconds]');

    if (!this.endTime || !this.hoursEl || !this.minutesEl || !this.secondsEl) return;

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);

    // The announcement bar and header are both position:fixed, so this strip is
    // fixed between them. Publish both heights so the CSS can place them.
    this.reposition = this.reposition.bind(this);
    this.reposition();
    window.addEventListener('resize', this.reposition);
    window.addEventListener('scroll', this.reposition, { passive: true });
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    window.removeEventListener('resize', this.reposition);
    window.removeEventListener('scroll', this.reposition);
    document.documentElement.classList.remove('pdp-sale-timer-active');
  }

  reposition() {
    const announcement = document.querySelector('.header-sections .page-announcement');
    // The bar is position:fixed, so offsetParent is always null — measure the box.
    const announcementHeight = announcement ? announcement.getBoundingClientRect().height : 0;

    // Present but zero-height means the bar is temporarily off screen (homepage
    // before scroll) — hide along with it. Absent entirely means it was removed,
    // so take its place at the very top.
    const announcementRemoved = announcement === null;

    // The homepage header is transparent over the hero video, so stay out of the
    // way until past it. custom-header-javascript.js flags .scrolled at
    // `innerHeight - 84`; follow that, with the same threshold as a fallback.
    const customHeader = document.querySelector('.custom-header');
    const pastHero =
      !document.body.classList.contains('template-index') ||
      (customHeader !== null && customHeader.classList.contains('scrolled')) ||
      window.scrollY > window.innerHeight - 84;

    const isActive =
      !this.hidden && pastHero && (announcementRemoved || announcementHeight > 0);
    const wrapper = this.closest('.pdp-sale-timer-section');

    if (wrapper) {
      wrapper.classList.toggle('is-announcement-visible', isActive);
      wrapper.classList.toggle('is-announcement-hidden', !isActive);
    }

    // Gates the header / main-content offsets. Without it the theme's own
    // spacing must stand exactly as it was.
    document.documentElement.classList.toggle('pdp-sale-timer-active', isActive);

    const root = document.documentElement.style;
    root.setProperty('--pdp-sale-timer-top', `${announcementHeight}px`);
    root.setProperty('--pdp-sale-timer-height', isActive ? `${this.offsetHeight}px` : '0px');
  }

  tick() {
    const remaining = Math.floor((this.endTime - Date.now()) / 1000);

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.render(0, 0, 0);
      if (this.hideWhenExpired) {
        this.hidden = true;
        this.reposition();
      }
      return;
    }

    this.render(Math.floor(remaining / 3600), Math.floor((remaining % 3600) / 60), remaining % 60);
  }

  render(hours, minutes, seconds) {
    this.setDigits(this.hoursEl, hours);
    this.setDigits(this.minutesEl, minutes);
    this.setDigits(this.secondsEl, seconds);
  }

  // Only touch the DOM when the value actually changes, then restart the roll
  setDigits(element, value) {
    const next = String(value).padStart(2, '0');
    if (element.textContent === next) return;

    element.textContent = next;
    element.classList.remove('is-ticking');
    void element.offsetWidth;
    element.classList.add('is-ticking');
  }
}

if (!customElements.get('pdp-sale-timer')) {
  customElements.define('pdp-sale-timer', PdpSaleTimer);
}
